import { lazy } from "react";
import {
  DashboardOutlined,
  EmailOutlined,
  PeopleOutlined,
  Poll,
  WhatsApp,
} from "@material-ui/icons";
import Constants from "../config/constants";
import RouteName from "./Route.name";
import PrimaryUserUpdateListView from "../views/PrimaryUserUpdate/List/PrimaryUserUpdate.view.jsx";
const MemberPollsCreate = lazy(() => import("../views/MemberPolls/Create/MemberPollsCreate.view.js"));
const MemberPolls = lazy(() => import("../views/MemberPolls/List/MemberPolls.js"));
const EventBasicCreate = lazy(() => import("../views/Events/EventBasicCreate/EventBasicCreate.view.js"));
const LanyardTemplateList = lazy(() => import("../views/LanyardTemplate/LanyardTemplateList.view.js"));
const LanyardTemplateCreate = lazy(() => import("../views/LanyardTemplate/Create/LanyardTemplateCreate.view.js"));
const VendorCreateView = lazy(() => import("../views/Vendor/Create/VendorCreate.view.jsx"));
const SubCategoryListView = lazy(() => import("../views/Vendor/Sub-Category/List/SubCategoryList.view.jsx"));
const VendorListView = lazy(() => import("../views/Vendor/List/VendorList.view.jsx"));
const PreferredPartnerList = lazy(() => import("../views/PreferredPartner/List/PreferredPartnerList.view.jsx"));
const PartnerTypeList = lazy(() => import("../views/PreferredPartner/PartnerTypeList/PartnerTypeList.view.jsx"));
const PreferredPartnerCreate = lazy(() => import("../views/PreferredPartner/Create/PreferredPartnerCreate.view.jsx"));
const PerferredPartnerTypeCreate = lazy(() => import("../views/PreferredPartner/TypeCreate/PerferredPartnerTypeCreate.view.jsx"));
const EmailBlockedUserList = lazy(() => import("../views/EmailBlockedUserList/List/EmailBlockedUserList.view.jsx"));
const BlockedUserList = lazy(() => import("../views/WABlockedUserList/List/BlockedUserList.view.jsx"));
const ELibraryAnalyticsView = lazy(() => import("../views/ELibraryDashboard/ELibraryAnalytics/ELibraryAnalytics.view.jsx"));
const SectionEngagementList = lazy(() => import("../views/ELibraryDashboard/ELibraryAnalytics/components/ListSectionEngagement/SectionEngagementList.view.jsx"));
const EmailCompList = lazy(() => import("../views/EmailComposer/EmailCompList/EmailCompList.component.js"));
const LetterHead = lazy(() => import("../views/EmailComposer/LetterHeadList/LetterList/LetterList.component.js"));
const EmailCompCreate = lazy(() => import("../views/EmailComposer/Create/EmailCompCreate.js"));
const LetterHeadCreate = lazy(() => import("../views/EmailComposer/LetterHeadList/Create/LetterHeadCreate.view.js"));
const WhatsappList = lazy(() => import("../views/Whatsapp/WhatsappList.view.js"));
const WhatsappCreate = lazy(() => import("../views/Whatsapp/Create/WhatsappCreate.view.js"));
const EmailCompDetailView = lazy(() => import("../views/EmailComposer/Detail/EmailCompDetail.view.jsx"));
const BroadcastList = lazy(() => import("../views/Broadcast/BroadcastList.view.js"));
const BroadcastCreate = lazy(() => import("../views/Broadcast/Create/BroadcastCreate.view.js"));

const MasterList = lazy(() => import("../views/master/MasterList/MasterList.view"));
const AdminUserList = lazy(() => import("../views/AdminUser/AdminUserList/AdminUserList.container"));
const AppUserList = lazy(() => import("../views/AppUsers/AppUserList/AppUserList.container"));
const UserProfile = lazy(() => import("../views/AppUserDetails/UserProfile/UserProfile.js"));
const FeedPost = lazy(() => import("../views/AppUserDetails/FeedsPost/FeedPost.js"));
const CommentPost = lazy(() => import("../views/AppUserDetails/CommentPost/CommentPost.js"));
const AssociateEvent = lazy(() => import("../views/AppUserDetails/AssociateEvent/AssociateEvent.js"));
const AssociateChapter = lazy(() => import("../views/AppUserDetails/AssociateChapter/AssociateChapter.js"));
const MemberList = lazy(() => import("../views/MemberList/MemberList.view"));
const StateFedCreate = lazy(() => import("../views/master/MasterList/StateFedCreate/StateFedCreate.view"));
const NationalMemDetail = lazy(() => import("../views/master/MasterList/NationalMemDetail/NationalMemDetail.view"));
const CityAssocList = lazy(() => import("../views/master/CityAssocList/CityAssocList.view"));
const CityAssCreate = lazy(() => import("../views/master/CityAssCreate/CityAssCreate.view"));
const EventList = lazy(() => import("../views/Events/EventList/EventList.view"));
const EventCreate = lazy(() => import("../views/Events/EventCreate/EventCreate.view"));

const PendingEventList = lazy(() => import('../views/PendingEvents/PendingEventList/PendingEventList.view'));
const PendingEventDetail = lazy(() => import('../views/PendingEvents/PendingEventDetail/PendingEventDetail.view'));
const LeadMemberList = lazy(() => import('../views/LeadMemberList/LeadMemberList.view'));
const MemberCreate = lazy(() => import('../views/MemberList/MemberCreate/MemberCreate.view'));
const MemberDetail = lazy(() => import('../views/MemberList/MemberDetail/MemberDetail.view'));
const PolicieLists = lazy(() => import('../views/Policies/PoliciesList/PoliciesListContainer'));
const StateMemberDetail = lazy(() => import('../views/master/StateMemberDetail/StateMemberDetail.view'));
const CityMemDetail = lazy(() => import('../views/master/CityMemDetail/CityMemDetail.view'));
const EventParticipantList = lazy(() => import('../views/EventParticipants/List/EventParticipantList'));
const EventDetail = lazy(() => import('../views/Events/EventDetail/EventDetail.view'));
const EventOrganiserList = lazy(() => import('../views/EventOrganisingCommittee/List/EventOrganiserList'));
const EventPollsList = lazy(() => import('../views/EventPolls/EventPollsList/EventPollsList.container'));
const EventPollsCreate = lazy(() => import('../views/EventPolls/EventPollsCreate/EventPollsCreate.view'));
const EventScheduleList = lazy(() => import('../views/Events/EventSchedule/EventScheduleList/EventScheduleContainer'));
const EventSpeaker_List = lazy(() => import('../views/EventSpeakers/EventSpeaker_List/Speakers_List'));
const SpeakerCreate = lazy(() => import('../views/EventSpeakers/EventSpeakers_Create/SpeakersCreate'));
const CityGuid_Create = lazy(() => import('../views/EventCityGuide/Create/CityGuide_View'));
const CityGuid_List = lazy(() => import('../views/EventCityGuide/Lists/CityGuide_list'));
const CityGuid_Content_List = lazy(() => import('../views/EventCityGuide/CityGuideContent/List/CityGuideContent_List'));
const Album_List = lazy(() => import('../views/GalleryAlbum/List/Album_List'));

const Album_Create = lazy(() => import("../views/GalleryAlbum/Create/Album_Create"));
const Album_Detail = lazy(() => import("../views/GalleryAlbum/Gallery_Detail/List/GalleryDetail"));
const EventOrganiserUserList = lazy(() => import("../views/EventOrganisingCommittee/UsersList/EventOrganiserUserList"));
const EventOrganiserUserCreateView = lazy(() => import("../views/EventOrganisingCommittee/UsersCreate/EventOrganiserUserCreate.view"));
const EventSponsor = lazy(() => import("../views/EventSponsor/List/EventSponsor.view"));
const EventSponsorCreate = lazy(() => import("../views/EventSponsor/Create/EventSponsorCreate.view"));
const TypeList = lazy(() => import("../views/EventSponsor/TypeList/TypeList.view"));
const TypeCreate = lazy(() => import("../views/EventSponsor/TypeCreate/TypeCreate.view"));
const EventBanner = lazy(() => import("../views/EventBanner/List/EventBanner.view"));
const EventBannerCreate = lazy(() => import("../views/EventBanner/Create/EventBannerCreate.view"));
const CityCompView = lazy(() => import("../views/EventCityGuide/CityGuideContent/Create/CityComp.view"));
const InforCenterLists = lazy(() => import("../views/Event_InfoCenter/List/InfoCenter_List"));
const InforCenter_Create = lazy(() => import("../views/Event_InfoCenter/Create/InfoCenter_Create"));
const YouTube_List = lazy(() => import("../views/Event_YoutubeStreem/List/YouTube_List.js"));
const YouTube_Create = lazy(() => import("../views/Event_YoutubeStreem/Create/YouTube_Create"));
const NotificationCreate = lazy(() => import("../views/Notification/NotificationCreate/NotificationCreate.view"));
const NotificationList = lazy(() => import("../views/Notification/NotificationList/NotificationList.view"));

const UserList = lazy(() => import("../views/EventDesk/User/List/UserList.view"));
const CategoryList = lazy(() => import("../views/EventDesk/Category/List/CategoryList.view"));
const EventUserCreateView = lazy(() => import("../views/EventDesk/User/Create/EventUserCreate"));
const CategoryCreateView = lazy(() => import("../views/EventDesk/Category/Create/CategoryCreate.view"));
const EventGallery = lazy(() => import("../views/EventGallery/List/EventGallery.view"));
const EventFeed = lazy(() => import("../views/EventFeed/List/EventFeed.view"));
const EventUserList = lazy(() => import("../views/EventUserRequest/List/EventUser_List"));
const BusinessList = lazy(() => import("../views/BusinessGreeting/Business.view"));
const ReportedList = lazy(() => import("../views/ReportedUser/ReportedList.js"));
const ReportedFeed = lazy(() => import("../views/ReportedFeed/ReportedFeed"));
const PollResult = lazy(() => import("../views/PollResults/PollResult"));
const BusinessCreate = lazy(() => import("../views/BusinessGreeting/BusinessCreate/BusinessCreate.view"));

const BusinessDetail = lazy(() => import("../views/BusinessGreeting/BusinessDetail/BusinessDetail.view"));
const NewDashboard = lazy(() => import("../views/dashboard/NewDashboard.view"));
const KnowledgeCenter = lazy(() => import("../views/KnowledgeCenter/KnowledgeCenter.view"));
const knowledgeCreate = lazy(() => import("../views/KnowledgeCenter/Create/Create.view"));
const knowledgeList = lazy(() => import("../views/KnowledgeCenter/CountryList/List.view"));
const knowledgeStampCreate = lazy(() => import("../views/KnowledgeCenter/CountryList/CreateStamp/Stamp.js"));
const VendorCategoryList = lazy(() => import("../views/Vendor/Category/List/CategoryList.view.jsx"));
const VendorApprovalList = lazy(() => import("../views/VendorApproval/List/VendorApprovalList.view.js"));
const VendorApprovalDetail = lazy(() => import("../views/VendorApproval/Detail/VendorApprovalDetail.view.js"));



const Roles = Constants.ROLES;

const dashboardRoutes = [
  {
    path: "/",
    sidebarName: "Dashboard",
    navbarName: "Admin Dashboard",
    icon: DashboardOutlined,
    component: NewDashboard,
    is_sidebar: true,
  },
  {
    path: `${RouteName.CHAPTERS_MASTER}`,
    sidebarName: "Chapters Master",
    navbarName: "Chapters Master",
    icon: PeopleOutlined,
    component: MasterList,
    is_sidebar: true,
    is_protect: true,
    roles: [Roles.CHAPTER_ADMIN, Roles.GENERAL],
  },
  {
    path: `${RouteName.USER_PROFILE + ":id"}`,
    component: UserProfile,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.FEED_POSTS + ":id"}`,
    component: FeedPost,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.COMMENTS}:id`,
    component: CommentPost,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.ASSOCIATED_EVENTS}:id`,
    component: AssociateEvent,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.ASSOCIATED_CHAPTERS}:id`,
    component: AssociateChapter,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.STATE_FEDERATION_CREATE}`,
    component: StateFedCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.STATE_FEDERATION_UPDATE}:id`,
    component: StateFedCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.NATIONAL_MEMBER_DETAIL}`,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.STATE_MEMBER_DETAIL}:id`,
    component: StateMemberDetail,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.CITY_MEMBER_DETAIL}:id`,
    component: CityMemDetail,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.CITY_ASSOCIATION_LIST}:id`,
    component: CityAssocList,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.CITY_ASSOCIATION_CREATE}`,
    icon: PeopleOutlined,
    component: CityAssCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.CITY_ASSOCIATION_UPDATE}:id`,
    component: CityAssCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.ADMIN}`,
    sidebarName: "Admin Users",
    navbarName: "Admin Users",
    icon: PeopleOutlined,
    component: AdminUserList,
    is_sidebar: true,
    is_protect: true,
    roles: [Roles.GENERAL],
  },
  {
    path: `${RouteName.APP}`,
    sidebarName: "App Users",
    navbarName: "App Users",
    icon: PeopleOutlined,
    component: AppUserList,
    is_sidebar: true,
    is_protect: true,
    roles: [Roles.GENERAL],
  },
  {
    path: `${RouteName.MEMBERS}`,
    sidebarName: "Members Companies",
    navbarName: "Members Companies",
    icon: PeopleOutlined,
    component: MemberList,
    is_sidebar: true,
    is_protect: true,
    roles: [Roles.GENERAL, Roles.CHAPTER_ADMIN],

  },
  {
    path: `${RouteName.MEMBERS_CREATE}`,
    component: MemberCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.MEMBERS_UPDATE}:id`,
    component: MemberCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.MEMBERS_DETAILS}:id`,
    component: MemberDetail,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.NEW_MEMBERS}`,
    sidebarName: "Members Users Request",
    navbarName: "Members Users Request",
    icon: PeopleOutlined,
    component: LeadMemberList,
    is_sidebar: true,
    is_protect: true,
    roles: [Roles.GENERAL, Roles.CHAPTER_ADMIN],
  },
  {
    path: `${RouteName.ALBUMS}`,
    sidebarName: "Gallery Album",
    navbarName: "Gallery Album",
    icon: PeopleOutlined,
    component: Album_List,
    is_sidebar: true,
    is_protect: true,
    roles: [Roles.GENERAL, Roles.CHAPTER_ADMIN],
  },
  {
    path: `${RouteName.ALBUMS_CREATE}`,
    component: Album_Create,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.ALBUMS_DETAILS}:id`,
    component: Album_Detail,
    is_sidebar: false,
    is_protect: true,
  },
  // {
  //   path: `${RouteName.ALBUMS_UPDATE_CREATE}:id`,
  //   sidebarName: "Gallery Album",
  //   navbarName: "Gallery Album",
  //   icon: PeopleOutlined,
  //   component: "Album_CoDetail",
  //   is_sidebar: false,
  //   is_protect: true,
  // },
  {
    path: `${RouteName.ALBUMS_UPDATE}:id`,
    component: Album_Create,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.POLICIES}`,
    sidebarName: "Reports and newsletters",
    navbarName: "Reports and newsletters",
    icon: PeopleOutlined,
    component: PolicieLists,
    is_sidebar: true,
    is_protect: true,
    roles: [Roles.GENERAL, Roles.CHAPTER_ADMIN],
  },
  {
    path: `${RouteName.NOTIFICATION}`,
    sidebarName: "Notification",
    navbarName: "Notification",
    icon: PeopleOutlined,
    component: NotificationList,
    is_sidebar: true,
    is_protect: true,
    roles: [Roles.GENERAL, Roles.CHAPTER_ADMIN],
  },
  {
    path: `${RouteName.KNOWLEDGE_CENTER}`,
    sidebarName: "Knowledge Center",
    navbarName: "Knowledge Center",
    icon: PeopleOutlined,
    component: KnowledgeCenter,
    is_sidebar: true,
    is_protect: true,
    roles: [Roles.GENERAL]
  },
  {
    path: `${RouteName.NOTIFICATION_CREATE}`,
    component: NotificationCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.NOTIFICATION_UPDATE}:id`,
    component: NotificationCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.EVENTS}`,
    sidebarName: "Events",
    navbarName: "Events",
    icon: PeopleOutlined,
    component: EventList,
    is_sidebar: true,
    is_protect: true,
    roles: [Roles.GENERAL, Roles.EVENT_MANAGER, Roles.CHAPTER_ADMIN],
  },
  {
    path: `${RouteName.EVENTS_SCEDULE}:id`,
    component: EventScheduleList,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.ADD_SPEAKERS_CREATE}`,
    component: SpeakerCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.ADD_SPEAKERS_UPDATE}:id`,
    component: SpeakerCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.EVENTS_SPEAKERS_LIST}:id`,
    component: EventSpeaker_List,
    is_sidebar: false,
    is_protect: true,
  },

  {
    path: `${RouteName.EVENT_CITYGUIDE}:id`,
    component: CityGuid_List,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.EVENT_CITYGUIDE_CREATE}`,
    component: CityGuid_Create,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.EVENT_CITYGUIDE_UPDATE}:id`,
    component: CityGuid_Create,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.CITYGUIDE_CONTENT_LIST}:id`,
    component: CityGuid_Content_List,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.CITYGUIDE_CONTENT_CREATE}`,
    component: CityCompView,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.CITYGUIDE_CONTENT_UPDATE}:id`,
    component: CityCompView,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.INFOR_CENTER}:id`, // :id
    component: InforCenterLists,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.INFOR_CENTER_CREATE}`,
    component: InforCenter_Create,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.INFOR_CENTER_UPDATE}:id`,
    component: InforCenter_Create,
    is_sidebar: false,
    is_protect: true,
  },

  {
    path: `${RouteName.EVENTS_CREATE}`,
    component: EventCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.EVENT_BASIC_CREATE}`,
    component: EventBasicCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.EVENT_BASIC_UPDATE}:id`,
    component: EventBasicCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.EVENTS_UPDATE}:id`,
    component: EventCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.EVENTS_DETAILS}:id`,
    component: EventDetail,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.PENDING_EVENTS}`,
    sidebarName: "Pending Events Approval",
    navbarName: "Pending Events Approval",
    icon: PeopleOutlined,
    component: PendingEventList,
    is_sidebar: true,
    is_protect: true,
    roles: [Roles.GENERAL],
  },

  {
    path: `${RouteName.PENDING_EVENTS_DETAILS}:id`,
    component: PendingEventDetail,
    is_sidebar: false,
    is_protect: true,
  },

  {
    path: `${RouteName.PENDING_EVENTS_DETAILS}:id`,
    component: PendingEventDetail,
    is_sidebar: false,
    is_protect: true,
  },

  {
    path: `${RouteName.EVENT_PARTICIPANTS}:id`,
    component: EventParticipantList,
    is_sidebar: false,
    is_protect: true,
  },

  {
    path: `${RouteName.EVENT_POLLS}:id`,
    component: EventPollsList,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.EVENT_POLLS_CREATE}`,
    component: EventPollsCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.EVENT_POLLS_UPDATE}:id`,
    component: EventPollsCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.EVENT_ORGANISER_USER_CREATE}`,
    component: EventOrganiserUserCreateView,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.EVENT_ORGANISER_USER_UPDATE}:id`,
    component: EventOrganiserUserCreateView,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.EVENT_ORGANISER_USER}:id`,
    component: EventOrganiserUserList,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.EVENT_ORGANISERS}:id`,
    component: EventOrganiserList,
    is_sidebar: false,
    is_protect: true,
  },

  {
    path: `${RouteName.EVENT_SPONSOR_CREATE}`,
    component: EventSponsorCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.EVENT_SPONSOR_UPDATE}:id`,
    component: EventSponsorCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.EVENT_SPONSOR_TYPE_CREATE}`,
    component: TypeCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.EVENT_SPONSOR_TYPE_UPDATE}:id`,
    component: TypeCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.EVENT_SPONSOR_USER}:id`,
    component: EventOrganiserUserList,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.EVENT_SPONSOR}:id`,
    component: EventSponsor,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.EVENT_BANNER}:id`,
    component: EventBanner,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.EVENT_SPONSOR_TYPE}:id`,
    component: TypeList,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.EVENT_BANNER_CREATE}`,
    component: EventBannerCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.EVENT_BANNER_UPDATE}:id`,
    component: EventBannerCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.YOUTUBE_STREEM}:id`,
    component: YouTube_List,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.YOUTUBE_STREEM_CREATE}`,
    component: YouTube_Create,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.EVENT_DESK_USER}:id`,
    component: UserList,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.EVENT_CATEGORY_USER}:id`,
    component: CategoryList,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.EVENT_DESK_CREATE}`,
    component: EventUserCreateView,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.EVENT_DESK_UPDATE}:id`,
    component: EventUserCreateView,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.EVENT_CATEGORY_CREATE}`,
    component: CategoryCreateView,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.EVENT_CATEGORY_UPDATE}:id`,
    component: CategoryCreateView,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.EVENT_GALLERY}:id`,
    component: EventGallery,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.EVENT_FEED}:id`,
    component: EventFeed,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.EVENT_USERLIST}`,
    sidebarName: "Event Users Request",
    navbarName: "Event Users Request",
    icon: PeopleOutlined,
    component: EventUserList,
    is_sidebar: true,
    is_protect: true,
    roles: [Roles.GENERAL, Roles.EVENT_MANAGER, Roles.CHAPTER_ADMIN]
  },
  {
    path: `${RouteName.REPORTED_USER}`,
    sidebarName: "Reported Users",
    navbarName: "Reported Users",
    icon: PeopleOutlined,
    component: ReportedList,
    is_sidebar: true,
    is_protect: true,
    roles: [Roles.GENERAL]
  },
  {
    path: `${RouteName.MEMBER_POLLS}`,
    sidebarName: "Member Polls",
    navbarName: "Member Polls",
    icon: PeopleOutlined,
    component: MemberPolls,
    is_sidebar: true,
    is_protect: true,
    roles: [Roles.GENERAL]
  },
  {
    path: `${RouteName.MEMBER_POLLS_CREATE}`,
    component: MemberPollsCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.MEMBER_POLLS_UPDATE}:id`,
    component: MemberPollsCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.REPORTED_FEED}`,
    sidebarName: "Reported Feed",
    navbarName: "Reported Feed",
    icon: PeopleOutlined,
    component: ReportedFeed,
    is_sidebar: true,
    is_protect: true,
    roles: [Roles.GENERAL]
  },
  {
    path: `${RouteName.BUSINESS_GREETING}`,
    sidebarName: "Business Greeting",
    navbarName: "Business Greeting",
    icon: PeopleOutlined,
    component: BusinessList,
    is_sidebar: true,
    is_protect: true,
    roles: [Roles.GENERAL]
  },
  {
    path: "null",
    sidebarName: "Email Composer",
    navbarName: "Email Composer",
    icon: EmailOutlined,
    is_sidebar: true,
    slug: "email",
    is_parent: true,
    roles: [Roles.GENERAL]
  },
  {
    path: `${RouteName.EMAIL_COM_LIST}`,
    sidebarName: "Email Composer",
    navbarName: "Email Composer",
    icon: EmailOutlined,
    component: EmailCompList,
    parent: "email",
    is_sidebar: true,
    is_protect: true,
    roles: [Roles.GENERAL]
  },
  {
    path: `${RouteName.EMAIL_BLOCKED_USER}`,
    sidebarName: "Email Blocked User List",
    navbarName: "Email Blocked User List",
    icon: EmailOutlined,
    component: EmailBlockedUserList,
    is_sidebar: true,
    is_protect: true,
    parent: "email",
    roles: [Roles.GENERAL]
  },
  {
    path: RouteName.LETTERHEAD_LIST,
    sidebarName: "Email Composer",
    navbarName: "Email Composer",
    icon: PeopleOutlined,
    component: LetterHead,
    is_sidebar: false,
    is_protect: true,
    // roles: [Roles.ACCOUNTANT,Roles.CORPORATE_HR],
  },
  {
    path: RouteName.EMAIL_COM_CREATE,
    sidebarName: "Email Composer",
    navbarName: "Email Composer",
    icon: PeopleOutlined,
    component: EmailCompCreate,
    is_sidebar: false,
    is_protect: true,
    // roles: [Roles.ACCOUNTANT,Roles.CORPORATE_HR],
  },
  {
    path: `${RouteName.EMAIL_COM_UPDATE}:id`,
    sidebarName: "Email Composer",
    navbarName: "Email Composer",
    icon: PeopleOutlined,
    component: EmailCompCreate,
    is_sidebar: false,
    is_protect: true,
    // roles: [Roles.ACCOUNTANT,Roles.CORPORATE_HR],
  },
  {
    path: `${RouteName.EMAIL_COM_DUPLICATE}:id`,
    sidebarName: "Email Composer",
    navbarName: `Email Composer`,
    component: EmailCompCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.EMAIL_COM_DETAIL}:id`,
    sidebarName: "Email Composer",
    navbarName: "Email Composer",
    icon: PeopleOutlined,
    component: EmailCompDetailView,
    is_sidebar: false,
    is_protect: true,
    // roles: [Roles.ACCOUNTANT,Roles.CORPORATE_HR],
  },
  {
    path: RouteName.LETTERHEAD_CREATE,
    sidebarName: "Email Composer",
    navbarName: "Email Composer",
    icon: PeopleOutlined,
    component: LetterHeadCreate,
    is_sidebar: false,
    is_protect: true,
    // roles: [Roles.ACCOUNTANT,Roles.CORPORATE_HR],
  },
  {
    path: `${RouteName.LETTERHEAD_UPDATE}:id`,
    sidebarName: "Email Composer",
    navbarName: "Email Composer",
    icon: PeopleOutlined,
    component: LetterHeadCreate,
    is_sidebar: false,
    is_protect: true,
    // roles: [Roles.ACCOUNTANT,Roles.CORPORATE_HR],
  },
  {
    path: `${RouteName.BUSINESS_GREETING_CREATE}`,
    component: BusinessCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.BUSINESS_GREETING}/:id`,
    component: BusinessCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.BUSINESS_GREETING_DETAIL}/:id`,
    component: BusinessDetail,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.KNOWLEDGE_CENTER_CREATE}`,
    sidebarName: "Knowledge Center",
    navbarName: "Knowledge Center",
    component: knowledgeCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.KNOWLEDGE_CENTER_UPDATE}/:id`,
    sidebarName: "Knowledge Center",
    navbarName: "Knowledge Center",
    component: knowledgeCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.KNOWLEDGE_CENTER_LIST}/:id`,
    sidebarName: "Knowledge Center",
    navbarName: "Knowledge Center",
    component: knowledgeList,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.KNOWLEDGE_CENTER_STAMP_CREATE}`,
    sidebarName: "Knowledge Center",
    navbarName: "Knowledge Center",
    component: knowledgeStampCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.KNOWLEDGE_CENTER_STAMP_CREATE}/:id`,
    sidebarName: "Knowledge Center",
    navbarName: "Knowledge Center",
    component: knowledgeStampCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: "null",
    sidebarName: "Whatsapp Composer",
    navbarName: "Whatsapp Composer",
    icon: WhatsApp,
    is_sidebar: true,
    slug: "whatsapp",
    is_parent: true,
    roles: [Roles.GENERAL]
  },
  {
    path: `${RouteName.WHATSAPP_LIST}`,
    sidebarName: "Template Composer",
    navbarName: "Template Composer",
    icon: WhatsApp,
    component: WhatsappList,
    is_sidebar: true,
    is_protect: true,
    parent: "whatsapp",
    roles: [Roles.GENERAL]
  },
  {
    path: `${RouteName.WHATSAPP_CREATE}`,
    component: WhatsappCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.WHATSAPP_DETAIL}:id`,
    component: WhatsappCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.WHATSAPP_UPDATE}:id`,
    component: WhatsappCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.BROADCAST_LIST}`,
    sidebarName: "Broadcast List",
    navbarName: "Broadcast List",
    icon: WhatsApp,
    component: BroadcastList,
    is_sidebar: true,
    is_protect: true,
    parent: "whatsapp",
  },
  {
    path: `${RouteName.BROADCAST_CREATE}`,
    component: BroadcastCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.BROADCAST_DETAIL}:id`,
    component: BroadcastCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.E_LIBRARY}`,
    sidebarName: "E-Library Analytics",
    navbarName: "E-Library Analytics",
    icon: Poll,
    component: ELibraryAnalyticsView,
    is_sidebar: true,
    is_protect: true,
    roles: [Roles.GENERAL]
  },
  {
    path: `${RouteName.SECTION_ENGAGEMENT}`,
    sidebarName: "E-Library Analytics",
    navbarName: "E-Library Analytics",
    component: SectionEngagementList,
    is_sidebar: false,
    is_protect: false,
  },
  {
    path: `${RouteName.BLOCKED_USER}`,
    sidebarName: "Blocked User List",
    navbarName: "Blocked User List",
    component: BlockedUserList,
    icon: WhatsApp,
    is_sidebar: true,
    is_protect: true,
    parent: "whatsapp",
  },
  {
    path: `${RouteName.PREFERRED_PARTNER}`,
    sidebarName: "Preferred Partners",
    navbarName: "Preferred Partners",
    component: PreferredPartnerList,
    icon: PeopleOutlined,
    is_sidebar: true,
    is_protect: true,
    roles: [Roles.GENERAL]
  },
  {
    path: `${RouteName.PREFERRED_PARTNER_TYPE}`,
    component: PartnerTypeList,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.PREFERRED_PARTNER_TYPE_CREATE}`,
    component: PerferredPartnerTypeCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.PREFERRED_PARTNER_TYPE_UPDATE}:id`,
    component: PerferredPartnerTypeCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.PREFERRED_PARTNER_CREATE}`,
    component: PreferredPartnerCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.PREFERRED_PARTNER_UPDATE}:id`,
    component: PreferredPartnerCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.LANYARD_TEMPLATE}`,
    sidebarName: "Lanyard Template",
    navbarName: "Lanyard Template",
    icon: PeopleOutlined,
    component: LanyardTemplateList,
    is_sidebar: true,
    is_protect: true,
    roles: [Roles.GENERAL]
  },
  {
    path: `${RouteName.LANYARD_TEMPLATE_CREATE}`,
    component: LanyardTemplateCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.LANYARD_TEMPLATE_UPDATE}:id`,
    component: LanyardTemplateCreate,
    is_sidebar: false,
    is_protect: true,
  },
  {
    path: `${RouteName.VENDOR_LIST}`,
    sidebarName: "Vendor Module",
    navbarName: "Vendor Module",
    component: VendorListView,
    icon: PeopleOutlined,
    is_sidebar: true,
    is_protect: true,
    roles: [Roles.GENERAL, Roles.CHAPTER_ADMIN]
  },
  {
    path: `${RouteName.PRIMARY_USER_UPDATE_LIST}`,
    sidebarName: "Primary User Update",
    navbarName: "Primary User Update",
    component: PrimaryUserUpdateListView,
    icon: PeopleOutlined,
    is_sidebar: true,
    is_protect: true,
    roles: [Roles.GENERAL]
  },
  {
    path: `${RouteName.VENDOR_CREATE}`,
    sidebarName: "Vendor Module",
    navbarName: "Vendor Module",
    component: VendorCreateView,
    icon: PeopleOutlined,
    is_sidebar: false,
    is_protect: true,
    // roles:[Roles.GENERAL]
  },
  {
    path: `${RouteName.VENDOR_UPDATE}:id`,
    sidebarName: "Vendor Module",
    navbarName: "Vendor Module",
    component: VendorCreateView,
    icon: PeopleOutlined,
    is_sidebar: false,
    is_protect: true,
    // roles:[Roles.GENERAL]
  },
  {
    path: `${RouteName.PRIMARY_USER_UPDATE}:id`,
    sidebarName: "Primary User Update",
    navbarName: "Primary User Update",
    component: VendorCreateView,
    icon: PeopleOutlined,
    is_sidebar: false,
    is_protect: true,
    // roles:[Roles.GENERAL]
  },
  {
    path: `${RouteName.CATEGORY}`,
    component: VendorCategoryList,
    is_sidebar: false,
    is_protect: true,
    roles: [Roles.GENERAL],
  },
  {
    path: `${RouteName.SUB_CATEGORY}:id`,
    component: SubCategoryListView,
    is_sidebar: false,
    is_protect: true,
    roles: [Roles.GENERAL],
  },

  {
    path: `${RouteName.VENDOR_APPROVAL_LIST}`,
    sidebarName: "Vendor Approval",
    navbarName: "Vendor Approval",
    component: VendorApprovalList,
    icon: PeopleOutlined,
    is_sidebar: true,
    is_protect: true,
    roles: [Roles.GENERAL]
  },

  {
    path: `${RouteName.VENDOR_APPROVAL_DETAIL}:id`,
    component: VendorApprovalDetail,
    is_sidebar: false,
    is_protect: true,
  },
];

export default dashboardRoutes;
